import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getLocale, pathFor, resolvePath, DEFAULT_LOCALE } from "./locales";
import { MESSAGES } from "./messages";

const LocaleContext = createContext(null);

export const LocaleProvider = ({ children }) => {
  const { pathname } = useLocation();
  const value = useMemo(() => {
    const { code, key } = resolvePath(pathname);
    const locale = getLocale(code);
    return {
      code,
      locale,
      dir: locale.dir,
      tag: locale.tag,
      routeKey: key ?? null,
      t: MESSAGES[code] ?? MESSAGES[DEFAULT_LOCALE],
      path: (routeKey, hash) => pathFor(code, routeKey, hash),
      pathIn: (otherCode) => pathFor(otherCode, key ?? "home"),
    };
  }, [pathname]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};

export const useLocale = () => {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error("useLocale must be used inside LocaleProvider");
  return ctx;
};

export const useT = () => useLocale().t;
